import { post } from "../../services/HttpService";

export class TelenganaNorthenApiService {
  static validations = {};

  static getBillDetails = (queryData = {}, config = {}) => {
    return post(
      `tgnpdcl/api/v1/fetchbilldetails/`,
      queryData,
      config
    ).catch((error) => ({
      success: false,
      data: error?.response?.data ?? {},
      status: error?.response?.status ?? 400,
    }));
  };

  static payBill = (queryData = {}, config = {}) => {
    return post(`tgnpdcl/api/v1/pay/`, queryData, config).catch(
      (error) => ({
        success: false,
        data: error?.response?.data ?? {},
        status: error?.response?.status ?? 400,
      })
    );
  };

  static fetchTxnDetails = (queryData = {}, config = {}) => {
    return post(
      `tgnpdcl/api/v1/transaction_details/`,
      queryData,
      config
    ).catch((error) => ({
      success: false,
      data: error?.response?.data ?? {},
      status: error?.response?.status ?? 400,
    }));
  };

  static downloadInvoice = (queryData = {}, config = {}) => {
    return post(
      `tgnpdcl/api/v1/download_reciept/`,
      queryData,
      config
    ).catch((error) => ({
      success: false,
      data: error?.response?.data ?? {},
      status: error?.response?.status ?? 400,
    }));
  };
}
